import { DateTime } from 'luxon';

import { Config } from '~/core/types';
import franchiseSelectors from '~/redux/ducks/config/selectors/franchiseSelectors';
import { PLAYOFFS_ID, REGULAR_SEASON_ID } from '~/utility/constants';

import { FilterState, ParamsFromSearch, StateBase } from './types';

const getQueryParamsFromState = (state: FilterState, separator: string): string => {
    const { seasonIdForDisplay, gameTypeId, franchiseId } = state;
    let paramString = `season=${seasonIdForDisplay}${separator}gameType=${gameTypeId}`;

    if (franchiseId) {
        paramString += `${separator}franchise=${franchiseId}`;
    }

    return paramString;
};

const getStateFromQueryParams = (searchString: string): StateBase => {
    const paramsFromSearch: ParamsFromSearch = searchString
        .replace(/%2C/g, ',')
        .substr(1)
        .split('&')
        .reduce((obj, param) => {
            if (!param) {
                return obj;
            }
            const keyValue = param.split('=');
            const key = keyValue[0];
            const value = Number.isNaN(Number(keyValue[1])) ? keyValue[1] : Number(keyValue[1]);

            return { ...obj, [key]: value };
        }, {});

    return {
        seasonId: paramsFromSearch.season,
        gameTypeId: paramsFromSearch.gameType,
        franchiseId: paramsFromSearch.franchise,
    };
};

const validateState = (state: FilterState, statsConfig: Config, filterName: string, newValue: number): StateBase => {
    const { franchiseData, seasonData } = statsConfig;

    // Validate seasons
    const seasonId = filterName.includes('season') ? newValue : state.seasonId;

    // Validate gameTypeId
    const gameTypeId = filterName.includes('gameType') ? newValue : state.gameTypeId;

    // Double check that playoffs is not selected when they did not occur
    const regularSeasonEndDate = seasonData && seasonId && seasonData[seasonId].regularSeasonEndDate;
    const validatedGameTypeId =
        regularSeasonEndDate && DateTime.fromISO(regularSeasonEndDate) > DateTime.local() && gameTypeId === PLAYOFFS_ID
            ? REGULAR_SEASON_ID
            : gameTypeId;

    // Validate franchiseId
    const franchiseId = filterName.includes('franchiseId') ? newValue : state.franchiseId;
    const selectedFranchise = franchiseData && franchiseData.find((f) => f.id === franchiseId);
    const validFranchise = selectedFranchise
        ? franchiseSelectors.isFranchiseValidForSeason(selectedFranchise, seasonId)
        : false;
    const validatedFranchiseId = validFranchise ? franchiseId : 0;

    return {
        seasonId,
        franchiseId: validatedFranchiseId,
        gameTypeId: validatedGameTypeId,
    };
};

export default {
    getQueryParamsFromState,
    getStateFromQueryParams,
    validateState,
};
